<div class="wrapper">
    <div class="input-item">
        <label>Title</label>
        <input type="text" matInput cdkFocusInitial [(ngModel)]="data.event.title">
    </div>

    <div class="input-item">
        <label>Image</label>
        <input matInput type="file" accept="image/*" (change)="onFileSelected($event)" [(ngModel)]="data.event.image" />
        <img [src]="url">
    </div>

    <div class="input-item">
        <label>Description</label>
        <textarea matInput [(ngModel)]="data.event.description"></textarea>
    </div>

    <div class="input-item">
        <label>Event Date</label>
        <input type="text" matInput [matDatepicker]="picker" [(ngModel)]="data.event.date">
        <mat-hint>MM/DD/YYYY</mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        <div *ngIf="showDateError">Please input a valid date</div>
    </div>

    <div class="input-item">
        <label>Time</label>
        <input type="text" matInput [(ngModel)]="data.event.time">
    </div>

    <div class="input-item">
        <label>Location</label>
        <input type="text" matInput [(ngModel)]="data.event.location">
    </div>

    <div class="input-item">
        <label>Price</label>
        <input type="text" matInput [(ngModel)]="data.event.price">
    </div>

    <div class="buttons" mat-dialog-actions>
        <button mat-button (click)="post()">Post</button>
        <button mat-button (click)="cancel()">Cancel</button>
        <button *ngIf="data.enableDelete" mat-fab color="primary" aria-label="Delete" [mat-dialog-close]="{ event: data.event, delete: true}">
            <mat-icon>delete</mat-icon>
        </button>
    </div>
</div>